import classNames from 'classnames';

import ItemNoEdit from 'common/components/item/ItemNoEdit';

import CartErrors from './components/CartErrors';
import CartSummary from './components/CartSummary';
import CouponForm from './components/CouponForm';
import CouponsAndPromos from './components/CouponsAndPromos';

const CheckoutSummary = (props) => {
  const { cart, isSummaryVisibleOnMobile, settings } = props;
  return (
    <section
      className={classNames(
        'c7-checkout-summary',
        isSummaryVisibleOnMobile && 'c7-visible'
      )}
    >
      <CartErrors cart={cart} />
      <div className="c7-cart-items">
        {cart.items.map((item) => (
          <ItemNoEdit item={item} key={item.id} settings={settings} />
        ))}
      </div>
      <CouponForm isVisible="true" cart={cart} />
      <CouponsAndPromos cart={cart} settings={settings} />
      <CartSummary cart={cart} settings={settings} />
    </section>
  );
};

export default CheckoutSummary;
